module.exports = __webpack_public_path__ + "static/menu-3d13e4bf6e0f0f9c794715efc0ca046f.jpg";